export enum SortOption {
  NAME_ASC = 'Name (A to Z)',
  NAME_DESC = 'Name (Z to A)',
  EXPIRATION_ASC = 'Expiration (Soonest)',
  EXPIRATION_DESC = 'Expiration (Latest)',
  DEFAULT = EXPIRATION_ASC
}
